import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from '@app/login';
import { CguComponent } from '@app/cgu';
import { ResetPasswordRequestComponent } from '@app/resetPasswordRequest';
import { AuthGuard, OtpGuard } from './services';
import { AuthPSCResolve } from './services/authPsc.resolve';
import { PscLinkAccountComponent } from './psc-link-account/psc-link-account.component';
import { RenewPasswordComponent } from '@app/renewPassword';
import { OtpComponent } from '@app/otp';
import { ResetPasswordComponent } from '@app/reset-password/reset-password.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'otp', component: OtpComponent, canActivate: [OtpGuard] },
  { path: 'reset-password/request', component: ResetPasswordRequestComponent },
  {
    path: 'reset-password/change',
    component: ResetPasswordComponent,
  },
  {
    path: 'pscAuth',
    resolve: {
      data: AuthPSCResolve,
    },
    component: PscLinkAccountComponent,
  },
  { path: 'cgu', component: CguComponent, canActivate: [AuthGuard] },
  { path: 'renewPassword', component: RenewPasswordComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
